var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"category-block",attrs:{"to":_vm.data.path,"data-testid":`parameter-category-${_vm.data.meta?.title}`}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.data.meta.title)))]),_c('span',{staticClass:"material-icons"},[_vm._v("chevron_right")])])
}
var staticRenderFns = []

export { render, staticRenderFns }